<template>
  <div
    v-bind:class="[
            { longBody: currentComponent == 'Devices' },
            { longBody: currentComponent == 'Services' },
            { calcbody: currentComponent == 'PeopleNo' },
            { calcbody: currentComponent == 'Calls' }
        ]"
  >
    <transition name="fade" mode="out-in">
      <div>
        <img class="logobody" src="../../../public/novologolaranja.svg" />
        <component :points="points" :range="range" :is="currentComponent"></component>
      </div>
    </transition>

    <div class="mobile-btn">
      <button v-on:click="changeComponentBack" class="calc_body__button btn-left">
        <img class="mobile-svg" src="../../../public/back.svg" />
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17">
          <path
            class="colorsvg"
            d="M7.046,1.54a2,2,0,0,1,2.908,0l3.86,4.087A2,2,0,0,1,12.36,9H4.64A2,2,0,0,1,3.186,5.627Z"
            transform="translate(0 17) rotate(-90)"
          />
        </svg>
        <span class="btn-left-text">ANTERIOR</span>
      </button>
      <div v-if="currentComponent === 'Calls'">
        <router-link
          class="calc_body__button btn-right btn-fix"
          :to="{ name: 'hire', params: {plan: $store.getters.getResult }}"
        >
          <span class="btn-right-text">PRÓXIMO</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17">
            <path
              class="colorsvg"
              d="M7.046,1.54a2,2,0,0,1,2.908,0l3.86,4.087A2,2,0,0,1,12.36,9H4.64A2,2,0,0,1,3.186,5.627Z"
              transform="translate(9) rotate(90)"
            />
          </svg>
          <img class="mobile-svg" src="../../../public/next.svg" />
        </router-link>
      </div>
      <div v-else>
        <button v-on:click="changeComponentNext" class="calc_body__button btn-right">
          <span class="btn-right-text">PRÓXIMO</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" viewBox="0 0 9 17">
            <path
              class="colorsvg"
              d="M7.046,1.54a2,2,0,0,1,2.908,0l3.86,4.087A2,2,0,0,1,12.36,9H4.64A2,2,0,0,1,3.186,5.627Z"
              transform="translate(9) rotate(90)"
            />
          </svg>
          <img class="mobile-svg" src="../../../public/next.svg" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PeopleNo from "../../components/PeopleNo";
import Devices from "../../components/Devices";
import Services from "../../components/Services";
import Calls from "../../components/Call";
import HirePlan from "../../components/HirePlan";

export default {
  name: "CalcBody",
  props: ["range", "points"],
  components: {
    Services,
    Devices,
    PeopleNo,
    Calls,
    HirePlan
  },

  data() {
    return {
      planresult: this.$store.state.planresult,
      currentComponent: "PeopleNo",
      isHidden: false
    };
  },

  created() {
      this.$store.watch
  },

  mounted() {
      this.$parent.$parent.changeToGrid()
  },

  methods: {
    swapComponent: function(component) {
      this.currentComponent = component;
    },
    changeComponentNext: function() {
      if (this.currentComponent === "PeopleNo") {
        this.currentComponent = "Devices";
      } else if (this.currentComponent === "Devices") {
        this.currentComponent = "Services";
      } else if (this.currentComponent === "Services") {
        this.currentComponent = "Calls";
      } else if (this.currentComponent === "Calls") {
        this.currentComponent = "HirePlan";
        this.isHidden = true;
      }
    },
    changeComponentBack: function() {
      if (this.currentComponent === "Calls") {
        this.currentComponent = "Services";
      } else if (this.currentComponent === "Services") {
        this.currentComponent = "Devices";
      } else if (this.currentComponent === "Devices") {
        this.currentComponent = "PeopleNo";
      } else if (this.currentComponent === "HirePlan") {
        this.currentComponent = "PeopleNo";
        this.isHidden = false;
      }
    },
    cleanCounter() {
      this.$store.commit("CLEAN_PLANS", 0);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/style";

img {
  width: 9px;
  height: 17px;
}

.logobody {
  position: absolute;
  right: 2em;
  top: 1em;
  width: 120px;
  height: 45px;
}

.calcbody {
  display: flex;
  align-items: center;
  padding: 65px 80px;
  z-index: 3;
  position: absolute;
  top: 30%;
  left: 34%;
  width: 900px;
  height: 479px;
  border-radius: 48px;
  background: $white 0% 0% no-repeat padding-box;
  box-shadow: 0px 20px 20px #4605894d;
  margin-right: auto;
  transform: none;
}

.longBody {
  padding: 65px 80px;
  z-index: 3;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
  width: 1100px;
  height: 774px;
  border-radius: 48px;
  background: $white 0% 0% no-repeat padding-box;
  box-shadow: 0px 20px 20px #4605894d;
  margin-right: auto;
  transform: none;
}

.calc-body__title {
  font-family: "Roboto", sans-serif;
  color: $light-orange;
  text-align: left;
  font-size: 21px;
}

.colorsvg {
  fill: #ffffff;
}

.mobile-svg {
  display: none;
}

@media only screen and (max-width: 600px) {
  .calcbody {
    padding: 1em;
    z-index: 3;
    width: 20em;
    height: 36em;
    border-radius: 48px;
    background: $white 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #4605894d;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
  }

  .longBody {
    padding: 1em;
    z-index: 3;
    width: 20em;
    height: 37em;
    border-radius: 48px;
    background: $white 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #4605894d;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
  }

  .mobile-svg {
    display: block;
  }

  .logobody {
    display: none;
  }

  .mobile-btn {
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 1.8em;
    min-width: 326px;
  }

  .calc_body__button {
    display: flex;
    position: relative;
    width: auto;
    height: auto;
    background-color: white;
    color: #6c4d90;
    box-shadow: none;
    font-weight: bold;
    font-size: 14px;
    font-family: "Roboto", sans-serif;
  }
}

@media only screen and (min-width: 1024px) {
  .calcbody {
    top: 50%;
    left: 50%;
    width: 41em;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    padding: 59px;
  }

  .longBody {
    top: 50%;
    left: 50%;
    margin-right: -50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 41em;
    height: 600px;
    padding: 65px;
  }

  .btn-right {
    padding-right: 29px;
    padding-left: 10px;
    right: -18%;
    text-align: right;
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
  }

  .btn-left-text {
    margin-left: 1.5em;
  }

  .btn-right-text {
    margin-right: 1.5em;
  }

  .btn-left {
    padding-left: 29px;
    left: -18%;
    text-align: left;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
  }
  .calc_body__button {
    display: flex;
    align-items: center;
    text-transform: uppercase;
    color: $white;
    font-weight: bold;
    font-size: 14px;
    font-family: "Roboto", sans-serif;
    width: 18%;
    height: 62px;
    background: $purple 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #4605894d;
    border: 0px;
    position: absolute;
    bottom: 21%;
    z-index: 1;
    cursor: pointer;
  }

  .calc_body__button:hover {
    box-shadow: 0px 10px 10px #4605894d;
  }
}

@media only screen and (min-width: 1800px) {
  .calcbody {
    top: 30%;
    left: 34%;
    margin-right: auto;
    transform: none;
  }

  .btn-right {
    padding-right: 29px;
    padding-left: 10px;
    right: -18%;
    text-align: right;
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
  }

  .btn-left-text {
    margin-left: 1.5em;
  }

  .btn-right-text {
    margin-right: 1.5em;
  }

  .btn-fix {
    padding-top: 2%;
  }

  .btn-left {
    padding-left: 29px;
    left: -18%;
    text-align: left;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
  }
}

@media only screen and (min-width: 601px) and (max-width: 1024px) {
  .calc_body__button {
    font-size: 12px;
  }
  .btn-right {
    padding-right: 29px;
    right: -18%;
    text-align: right;
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
  }

  .btn-left-text {
    margin-left: 1.5em;
  }

  .btn-right-text {
    margin-right: 1.5em;
  }

  .btn-fix {
    padding-top: 2%;
  }

  .btn-left {
    padding-left: 29px;
    left: -18%;
    text-align: left;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.fade-enter {
  transform: translateX(31px);
}
.fade-leave-active {
  transform: translateX(-31px);
}
</style>
